export default __webpack_public_path__ + "static/media/cafeteria.6b0780cb.svg";